import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';
import MatchResults from '../components/MatchResults';

const SAMPLE_JD = `Senior Frontend Engineer – FinTech Startup

We're looking for a Senior Frontend Engineer with:
• 3+ years experience with React and modern JavaScript (ES6+)
• Strong understanding of state management (Redux, Context API, Zustand)
• Experience with TypeScript and type-safe development
• Familiarity with REST APIs and backend integration
• Experience with performance optimization (useMemo, useCallback, lazy loading)
• Knowledge of Node.js and Express
• Git workflow familiarity

Responsibilities:
• Build and maintain high-performance React applications
• Collaborate with backend engineers on API design
• Participate in code reviews and architectural discussions`;

export default function AnalyzePage() {
  const [form, setForm] = useState({ jobTitle: '', company: '', jobDescription: SAMPLE_JD });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const navigate = useNavigate();

  const handleAnalyze = async () => {
    if (!form.jobDescription.trim()) { toast.error('Please enter a job description'); return; }
    setLoading(true);
    try {
      const res = await api.post('/match/analyze', form);
      setResult(res.data.result);
      toast.success('Analysis complete!');
    } catch (err) {
      if (err.response?.status === 404) {
        toast.error('Please upload your resume first');
        navigate('/upload');
      } else {
        toast.error(err.response?.data?.message || 'Analysis failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div style={{ marginBottom: 32 }}>
        <div style={{ fontFamily: 'Syne', fontSize: 26, fontWeight: 800, marginBottom: 8 }}>🔍 Analyze Match</div>
        <p style={{ color: 'var(--muted)', fontSize: 14 }}>Paste any job description to get your AI match score instantly.</p>
      </div>

      {!result ? (
        <div className="card">
          <div className="two-col" style={{ marginBottom: 0 }}>
            <div className="form-group">
              <label className="form-label">Job Title</label>
              <input className="input" placeholder="e.g. Frontend Engineer" value={form.jobTitle}
                onChange={e => setForm({ ...form, jobTitle: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Company</label>
              <input className="input" placeholder="e.g. Google" value={form.company}
                onChange={e => setForm({ ...form, company: e.target.value })} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Job Description *</label>
            <textarea className="textarea" rows={14} value={form.jobDescription}
              onChange={e => setForm({ ...form, jobDescription: e.target.value })}
              placeholder="Paste the full job description here..." />
            <div style={{ textAlign: 'right', fontSize: 11, color: 'var(--muted)', marginTop: 4 }}>{form.jobDescription.length} characters</div>
          </div>

          <button className="btn btn-primary" disabled={loading || !form.jobDescription.trim()} onClick={handleAnalyze}
            style={{ fontSize: 16, padding: '16px 36px' }}>
            {loading ? '⏳ Analyzing with AI...' : '🚀 Analyze Match'}
          </button>
        </div>
      ) : (
        <>
          <MatchResults result={result} jobTitle={form.jobTitle} company={form.company} />
          <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
            <button className="btn btn-ghost" onClick={() => setResult(null)}>← New Analysis</button>
            <button className="btn btn-ghost" onClick={() => navigate('/history')}>View History</button>
          </div>
        </>
      )}
    </div>
  );
}
